<template>
  <div class="product-list">
    <div class="productWrap">
      <div class="ItemWrap" style="padding-left: 0;">
        <div v-for="(product, index) in 20" :key="index" class="sItemWrap"   @click="goToDetail(product.index)">
          <div>
            <img class="imgWrap" src="../assets/zhonghua.png" alt="">
          </div>
          <div class="bqWrap">
            <div class="titleWrap">卷烟零售价格标签</div>
            <div style="background: #fff;">
              <div>
                <span>品牌 </span><span class="bFont">中华(硬盒)</span>
              </div>
              <div>
                <span>产地</span><span class="bFont">云南</span><span>价格</span><span class="bFont"
                  style="color: red;">100</span><span>元/盒</span>
              </div>

            </div>
          </div>

        </div>


      </div>
      <div style="display: grid;width: 100%;height: 100%;grid-template-columns: repeat(2,1fr);gap: 10px;">
        <div v-for="(product, index) in 8" :key="index" class="sItemWrap">
          <div>
            <img style="height: 100px;" src="../assets/zhonghua.png" alt="">
          </div>
          <div class="bqWrap">
            <div class="titleWrap">卷烟零售价格标签</div>
            <div style="background: #fff;">
              <div>

                <span>品牌 </span><span class="bFont">中华(硬盒)</span>
              </div>
              <div>
                <span>产地</span><span class="bFont">云南</span><span>价格</span><span class="bFont"
                  style="color: red;">100</span><span>元/盒</span>
              </div>

            </div>
          </div>

        </div>
      </div>
      <div class="ItemWrap">
        <div v-for="(product, index) in 20" :key="index" class="sItemWrap">
          <div>
            <img class="imgWrap" src="../assets/zhonghua.png">
          </div>
          <div class="bqWrap">
            <div class="titleWrap">卷烟零售价格标签</div>
            <div style="background: #fff;">
              <div>
                <span>品牌 </span><span class="bFont">中华(硬盒)</span>
              </div>
              <div>
                <span>产地</span><span class="bFont">云南</span><span>价格</span><span class="bFont"
                  style="color: red;">100</span><span>元/盒</span>
              </div>

            </div>
          </div>

        </div>


      </div>
      <!-- <div 
        v-for="product in products" 
        :key="product.index" 
        class="product-card"
        @click="goToDetail(product.index)"
      >
      
        <div class="product-image">
          <img 
            :src="require(`../assets/${product.pNmae}.png`)" 
            :alt="product.cname"
            class="cigarette-img"
          >
        </div>
        
       
        <div class="price-tag" :class="{ 'top-recommend': product.isTop === '1' }">
          <div class="tag-header">卷烟零售价格标签</div>
          <div class="tag-content">
            <p><strong>{{ product.cname }}</strong></p>
            <p><span class="price">¥{{ product.price }}/盒</span></p>
          </div>
          <div v-if="product.isTop === '1'" class="recommend-badge">店长推荐</div>
        </div>
      </div>  -->
    </div>
  </div>
</template>

<script>
import ycItem from '../utils/pro.ts'

export default {
  name: 'ProductList',
  data() {
    return {
      products: ycItem
    }
  },
  methods: {
    goToDetail(index) {
      this.$router.push(`/detail/${index}`)
    }
  }
}
</script>

<style scoped>
.product-list {
  height: 100vh;
  background-image: url('../assets/backgroundImg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 5px;
 box-sizing: border-box;
}



.productWrap {
  display: grid;
  grid-template-columns: 40% auto 40%;
  height: 100%;
  width: 100%;
 
  box-sizing: border-box;
  gap: 10px;
}

.ItemWrap {
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
   padding: 10px;
}

.sItemWrap {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.imgWrap {
  height: 80px;
}

.bqWrap {
  flex: 1;
  overflow: hidden;
  font-size: 8px;
}

.titleWrap {
  font-size: 10px;
  background: #00441b;
  color: #fff;
}

.bFont {
  font-size: 10px;
  text-decoration: underline;
}
</style>